import { ICreateAvaliacaoHabilidadeUseCase } from "../../../presentation/useCases/create/create_avaliacao_habilidade_use_case";
import { AvaliacaoHabilidade } from "../../models/avaliacao_habilidade";
import { HabilidadeItem } from "../../models/habilidade_item";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * CreateAvaliacaoHabilidadeUseCase
 */

export class CreateAvaliacaoHabilidadeUseCase implements ICreateAvaliacaoHabilidadeUseCase {
  private _avaliacaoHabilidade!: AvaliacaoHabilidade;
  private _habilidades!: HabilidadeItem[];

  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async createAvaliacaoHabilidade(
    idFuncionario: number,
    idCargo: number,
  ): Promise<void> {
    const { avaliacaoHabilidade, habilidades } = await this.repository.createAvaliacaoHabilidade(idFuncionario, idCargo);

    this._avaliacaoHabilidade = avaliacaoHabilidade;
    this._habilidades = habilidades;
  }

  get avaliacaoHabilidade(): AvaliacaoHabilidade {
    return this._avaliacaoHabilidade;
  }

  get habilidades(): HabilidadeItem[] {
    return this._habilidades;
  }
}